// packages/frontend-app-platform/src/data/ws/logic.ts
import { call } from 'typed-redux-saga';
import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
} from '@owl-frontend/redux';
import type { ConnectionState } from './WsManager';
import { platformWebSocketManager } from './WsManager';

function* initializeWebSocket() {
  yield* call([platformWebSocketManager, platformWebSocketManager.start]);
}

function* teardownWebSocket() {
  yield* call([platformWebSocketManager, platformWebSocketManager.stop]);
}

export interface WebSocketState {
  connectionState: ConnectionState;
  actions: {
    initializeWebSocket: AsyncActionState;
    teardownWebSocket: AsyncActionState;
  };
}

const initialState: WebSocketState = {
  connectionState: 'idle',
  actions: {
    initializeWebSocket: { status: 'uninitialized' },
    teardownWebSocket: { status: 'uninitialized' },
  },
};

const slice = setupSlice('websocket', initialState)
  .addAsyncSagas(
    {
      initializeWebSocket,
      teardownWebSocket,
    },
    { timeoutLimit: -1 }
  )
  .addReducers({
    setConnectionState: (
      state: WebSocketState,
      action: { payload: ConnectionState }
    ) => {
      state.connectionState = action.payload;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
